<script lang="ts">
    import MemberComponent from "../components/Member.svelte";
    import { getAllClubMembers } from "../firestore";
    import { Table } from 'svelte-materialify/src';
</script>

<div class="members">
    <Table dense>
        <thead>
            <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Team</th>
            </tr>
        </thead>
        <tbody>
            {#await getAllClubMembers()}
                <i>Loading...</i>
            {:then members}
                {#each members as member}
                    <tr>
                        <td><MemberComponent value={member} /></td>
                        <td>{member.email}</td>
                        <td>{member.team}</td>
                    </tr>
                {/each}
            {/await}
        </tbody>
    </Table>
</div>

<style>
    .members {
        max-width: 800px;
        margin: 0 auto;
    }
</style>